<template>
  <div class="page">
    <div class="content-center">
      <!-- 步骤条 -->
      <div class="steps">
        <div class="step-item bright">
          <div class="step-item-num">1</div>
          <div class="step-item-title">填写信息</div>
        </div>
        <div class="step-item">
          <div class="step-item-num">2</div>
          <div class="step-item-title">提交审核</div>
        </div>
        <div class="step-item">
          <div class="step-item-num">3</div>
          <div class="step-item-title">注册成功</div>
        </div>
      </div>
      <!-- 表单录入 -->
      <el-form ref="ruleForm" :model="entity" :rules="rules" label-width="auto">
        <div class="form-card">
          <div class="form-card-title">基础信息</div>
          <div class="form-card-body">
            <el-form-item label="企业名称:" prop="name">
              <el-input v-model="entity.name" placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item label="工商注册号:" prop="businessNo">
              <el-input v-model="entity.businessNo" placeholder="请输入工商注册号" maxlength="18" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="企业法人:" prop="legal">
              <el-input v-model="entity.legal" placeholder="请输入企业法人"></el-input>
            </el-form-item>
            <el-form-item label="办公地址:" prop="officeAddress">
              <el-input v-model="entity.officeAddress" placeholder="请输入办公地址"></el-input>
            </el-form-item>
            <el-form-item label="联系人:" prop="linkMan">
              <el-input v-model="entity.linkMan" placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系方式:" prop="linkPhone">
              <el-input
                v-model="entity.linkPhone"
                placeholder="请输入联系方式"
                maxlength="11"
                show-word-limit
                @input="limitNumber('linkPhone', $event)"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系方式公开项:" prop="contactPublicInfo">
              <el-input v-model="entity.contactPublicInfo" placeholder="请输入联系方式公开项"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-card">
          <div class="form-card-title">资质信息</div>
          <div class="form-card-body">
            <el-form-item label="企业简介:" prop="profile">
              <el-input v-model="entity.profile" type="textarea" maxlength="500" show-word-limit placeholder="请输入企业简介"></el-input>
            </el-form-item>
            <el-form-item label="擅长领域:" prop="expertiseList">
							<el-select v-model="entity.expertiseList" placeholder="请选择擅长领域" multiple>
								<el-option v-for="item in options.CustomerCategory" :key="item.id" :label="item.label" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
            <!-- <el-form-item label="子系统:" prop="subSystemIdList">
							<el-select v-model="entity.subSystemIdList" placeholder="请选择子系统" multiple>
								<el-option v-for="item in options.subSystemList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item> -->
            <el-form-item label="资质证书:" prop="qualificationUrl">
							<el-upload
								:action="uploadUrl"
								list-type="picture-card"
								accept="image/*"
								:limit="5"
                multiple
								:before-upload="beforeImageUpload"
								:on-success="(res, file, list) => uploadChange('qualificationUrl', list)"
								:on-remove="(file, list) => uploadChange('qualificationUrl', list)"
							>
								<i class="el-icon-plus"></i>
								<div slot="tip" class="el-upload__tip">只能上传图片文件，且不超过5MB</div>
							</el-upload>
						</el-form-item>
            <el-form-item label="公司规模:" prop="companyScale">
              <el-input v-model="entity.companyScale" placeholder="请输入公司规模" @input="limitNumber('companyScale', $event)">
                <template slot="append">人</template>
              </el-input>
            </el-form-item>
            <el-form-item label="年营业额区间:" prop="annualSalesMin">
							<div style="display: flex;">
								<el-input v-model="entity.annualSalesMin" placeholder="请输入" @change="limitNumber('annualSalesMin', $event, 2)">
									<template slot="append">万元</template>
								</el-input>
								<span style="margin: 0 12px;">至</span>
								<el-input v-model="entity.annualSalesMax" placeholder="请输入" @change="limitNumber('annualSalesMax', $event, 2)">
									<template slot="append">万元</template>
								</el-input>
							</div>
						</el-form-item>
            <el-form-item label="区域交付能力:" prop="areaList">
							<province-city v-model="entity.areaList"></province-city>
						</el-form-item>
          </div>
        </div>
        <div class="form-card">
          <div class="form-card-title">协议信息</div>
          <div class="form-card-body">
            <el-form-item label="合作协议:" prop="agreementUrl">
              <el-upload
								:action="uploadUrl"
								accept=".pdf"
								:limit="1"
								:before-upload="beforePdfUpload"
								:on-success="(res, file, list) => uploadChange('agreementUrl', list)"
								:on-remove="(file, list) => uploadChange('agreementUrl', list)"
							>
								<el-button stopCountDown>上传协议</el-button>
								<el-button type="text" @click.stop="downloadTemplate">下载模板</el-button>
								<span slot="tip" style="margin-left: 10px;">只能上传pdf，且不超过10MB</span>
							</el-upload>
						</el-form-item>
          </div>
        </div>
        <div class="form-card">
          <el-tabs v-model="activeTab">
            <el-tab-pane name="successfulCase" label="成功案例">
              <successful-case-bom ref="successfulCase" :type="entity.type"></successful-case-bom>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-form>
    </div>
    <div class="action-bar">
      <div class="primary-btn" @click="submitForm('ruleForm')">提交</div>
    </div>
    <!-- 流程弹窗 -->
    <send-workflow ref="sendWorkFlow" save></send-workflow>
  </div>
</template>

<script>
import TeamAuthApi from '@/api/supplier/teamAuthApi.js';
import OrderTypeApi from '@/api/supplier/orderType.js';
import DictionaryApi from '@/api/setting/dictionaryApi.js';
import MaterialCategoryApi from '@/api/material/categoryApi.js';

import SuccessfulCaseBom from './components/successfulCaseBom.vue';
import ProvinceCity from '@/components/province-city';
import sendWorkflow from '@/components/workflow/sendWorkflow.vue';

export default {
  components: {
    SuccessfulCaseBom,
    ProvinceCity,
    sendWorkflow
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_URL + 'longstron/base/doc/file/upload',
      activeTab: 'successfulCase',
			entity: {
				type: 'PROGRAMME',
				name: '',
				businessNo: '',
				legal: '',
				officeAddress: '',
				linkMan: '',
				linkPhone: '',
				contactPublicInfo: '',
				profile: '',
				expertiseList: [],
				expertise: '',
        subSystemIdList: [],
				subSystemId: '',
				teamProportion: '',
				qualificationUrl: '',
				companyScale: null,
				annualSalesMin: null,
				annualSalesMax: null,
				areaList: [null],
				area: '',
				agreementUrl: '',
				caseInfoList: []
			},
      rules: {
				type: [{ required: true, message: '请选择认证类型' }],
				name: [{ required: true, message: '请输入企业名称' }],
				businessNo: [{ required: true, message: '请输入工商注册号' }],
				legal: [{ required: true, message: '请输入企业法人' }],
				officeAddress: [{ required: true, message: '请输入办公地址' }],
				linkMan: [{ required: true, message: '请输入联系人' }],
				linkPhone: [{ required: true, message: '请输入联系方式' }],
				contactPublicInfo: [{ required: true, message: '请输入联系方式公开项' }],
				profile: [{ required: true, message: '请输入企业简介' }],
				expertiseList: [{ required: true, message: '请选择擅长领域' }],
        // subSystemIdList: [{ required: true, message: '请选择子系统' }],
				areaList: [{ required: true, message: '请选择区域交付能力' }],
				teamProportion: [{ required: true, message: '请输入团队分成比例' }],
				// agreementUrl: [{ required: true, message: '请上传合作协议' }]
			},
			options: {
				CertificationTypeEnum: [], // 认证类型
				CustomerCategory: [], // 擅长领域
				ServiceDefineList: [], // 擅长领域(服务生态供应商)
        subSystemList: [], // 子系统
			},
      workflow: {
				title: '解决方案供应商',
				baseUrl: TeamAuthApi.baseUrl(),
				permissionCode: 'official1401',
				commitWorkflow: true,
				auditPageUrl: 'pages/official/ecomanagement/teamAuth/teamAuthView.vue',
				entityCode: null, //实体code
				entityId: null //实体id
			},
    }
  },
	created() {
		this.getEnumData(['CertificationTypeEnum']);
		this.getDataDictionary();
		this.getServiceDefineList();
    this.getSubsystemList();
	},
  methods: {
		/**
		 * @description 获取枚举类数据
		 * @param {Array} enumClass 枚举类类名
		 */
		getEnumData(enumClass) {
			TeamAuthApi.getByEnumClass(enumClass).then(res => {
				if (res != null && res.code === '00000') {
					this.options = { ...this.options, ...res.model };
				}
			});
		},
		/**
		 * @description 获取字典行业类别(擅长领域)
		 */
		getDataDictionary() {
			DictionaryApi.getByDictKey("CustomerCategory").then(res => {
				if (res != null && res.code === '00000') {
					this.options.CustomerCategory = res.rows;
				}
			});
		},
		getServiceDefineList() {
			OrderTypeApi.query({ pagination: false, serviceTypeId: "1506562136545071104" }).then(res => {
				if (res != null && res.code === '00000') {
					this.options.ServiceDefineList = res.rows;
				}
			});
		},
    /**
		 * @description 获取子系统
		 */
		getSubsystemList() {
			MaterialCategoryApi.getSubsystem().then(res => {
				if (res != null && res.code === '00000') {
					this.options.subSystemList = res.rows;
				}
			});
		},
    limitNumber(field, value, decimal) {
      let number = '';
      if (decimal) number = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
      else number = value.replace(/[^\d]/g, '');
      if (number === '') number = '';
      if (decimal) number = Number(number).toFixed(decimal);
      return this.entity[field] = number;
    },
		beforeImageUpload(file) {
			const isImage = file.type.startsWith('image/');
			const isLt5M = file.size / 1024 / 1024 < 5;
			if (!isImage) {
				this.$message.error('只能上传图片文件!');
				return false;
			}
			if (!isLt5M) {
				this.$message.error('图片大小不能超过 5MB!');
				return false;
			}
			return true;
		},
		beforePdfUpload(file) {
			const isPdf = file.type === 'application/pdf';
			const isLt5M = file.size / 1024 / 1024 < 10;
			if (!isPdf) {
				this.$message.error('只能上传PDF文件!');
				return false;
			}
			if (!isLt5M) {
				this.$message.error('文件大小不能超过 10MB!');
				return false;
			}
			return true;
		},
		uploadChange(field, list) {
			this.entity[field] = list.map(v => v.uid ? v.response?.model?.httpFilePath : v.url).join(',');
		},
		downloadTemplate() {
			const url = 'https://longstron.oss-cn-shanghai.aliyuncs.com/2026/01/21/15/48fee1d0278a4aa6bedc3f9614f01159.docx';
			const link = document.createElement('a');
			link.style.display = 'none';
			// 设置下载地址
			link.setAttribute('href', url);
      link.setAttribute('target', '_blank');
			// 设置文件名
			link.setAttribute('download', '合作协议模板.docx');
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		/**
		 * @description: 提交保存新增
		 */
		submitForm(formName) {
			Promise.all([this.$refs[formName].validate()]).then(valid => {
				if (valid) {
					this.entity.area = this.entity.areaList.join(',');
					this.entity.expertise = this.entity.expertiseList.join(',');
          this.entity.subSystemId = this.entity.subSystemIdList.join(',');
					this.entity.caseInfoList = this.$refs['successfulCase'].getStoreRows();

          TeamAuthApi.addModel(this.entity).then(res => {
            if (res != null && res.code === '00000') {
              this.$message.success('保存成功！');
              this.$router.push('./submitted');
            }
          });

					/* this.workflow.title = `解决方案供应商认证-企业名称【${this.entity.name}】`;
					this.$refs['sendWorkFlow'].openWorkflowDialog(this.workflow, this.entity, () => {
            this.$message.success('发送成功！');
            this.cancel();
          }); */
				}
			});
		},
		/**
		 * @description: 取消返回列表
		 */
		cancel() {
			// this.$router.push('./list');
			this.$router.back();
		}
	}
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 48px;
  .steps {
    height: 74px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;

    .step-item {
      display: flex;
      align-items: center;
      + .step-item {
        margin-left: 160px;
        position: relative;
        &::before {
          content: '';
          width: 128px;
          height: 1px;
          background-image: linear-gradient(to right, #C4C4C4 0%, #C4C4C4 50%, transparent 50%, transparent 50%);
          background-size: 10px 100%;
          position: absolute;
          left: -16px;
          top: 50%;
          transform: translate(-100%, -50%);
        }
      }
      .step-item-num {
        width: 24px;
        height: 24px;
        margin-right: 12px;
        border-radius: 50%;
        background-color: #EDEFF2;
        color: #979EA5;
        line-height: 24px;
        text-align: center;
      }
      &.bright {
        .step-item-num {
          background-color: @primary-color;
          color: #fff;
        }
        .step-item-title {
          font-family: @font-medium;
          color: @default-color;
        }
      }
    }
  }

  .form-card {
    margin-top: 24px;
    padding: 24px 32px;
    background-color: #fff;
    border-radius: 4px;
    .form-card-title {
      padding-bottom: 20px;
      font-family: @font-medium;
      font-size: 20px;
    }
    .form-card-body {
      width: 70%;
      margin: 0 auto;
      .el-select,
      .el-input-number {
        width: 100%;
      }
      :deep(.el-form-item__label) {
        font-family: @font-medium;
        color: @default-color;
      }
    }
  }

  .action-bar {
    margin-top: 48px;
    height: 100px;
    background-color: #fff;
    box-shadow: 0px -4px 15px 0px rgba(0,0,0,0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    .primary-btn {
      width: 185px;
      height: 49px;
    }
  }
}

.el-upload__tip {
  // margin-top: 0px;
  font-size: 14px;
  line-height: 22px;
}

:deep(.el-upload--picture-card) {
  width: 110px !important;
  height: 110px !important;
  line-height: 108px;
}
:deep(.el-upload-list--picture-card) {
  margin-bottom: -8px;
  display: inline-flex;
  .el-upload-list__item {
    width: 110px !important;
    height: 110px !important;
  }
}
</style>
